import { ReactComponent as NoCertificateSVG } from "./no-certificate-regular.svg";
import { ReactComponent as NoHistorySVG } from "./no-history-regular.svg";
import { ReactComponent as NoMechanicalReportSVG } from "./no-mechanical-report-regular.svg";
import { ReactComponent as TransmissionSVG } from "./transmission-regular.svg";

const iconsViewBox = "0 0 24 24";

const getIcon = (name: string, color: string, className?: string) => {
  switch (name) {
    case "no-certificate":
      return (
        <NoCertificateSVG
          viewBox={iconsViewBox}
          className={className}
          fill={color}
        />
      );
    case "no-history":
      return (
        <NoHistorySVG
          viewBox={iconsViewBox}
          className={className}
          fill={color}
        />
      );
    case "no-mechanical-report":
      return (
        <NoMechanicalReportSVG
          viewBox={iconsViewBox}
          className={className}
          fill={color}
        />
      );
    case "transmission":
      return (
        <TransmissionSVG
          viewBox={iconsViewBox}
          className={className}
          fill={color}
        />
      );
  }
};

export const iconMapper = (name: string, color: string, className?: string) => {
  return getIcon(name, color, className);
};
